import { PageControl } from './page-control';
import { Params } from '@angular/router';
import { AudioHelper } from '@app/views/public/plugin-raio-x/plugin-raio-x.service';
import { TranscriptionResult } from '@app/views/private/admin/model/admin-models';

const OBJECT_KEY_NAMES = [
  'evalDealerIds',
  'oemDealerIds',
  'statuses',
  'segments',
  'reasons',
  'makeIds',
  'modelIds',
  'cityIds',
  'ufs'
];
const NUMBER_KEY_NAMES = ['page'];
const BOOLEAN_KEY_NAMES = [];
const IGNORED_KEY_NAMES = ['pageControl'];
const PAGE_CONTROL_KEY_NAMES = ['page', 'sortField', 'sortDirection'];

export class EvalLeadFilter {
  evalDealerIds: string[];
  oemDealerId: string;
  oemDealerIds: string[];
  pageControl: PageControl;
  searchQuery: string;
  segments: string[];
  statuses: string[];
  reasons: string[];
  reasonsArchives: string[];
  sellerIds: string[];
  priceType: string;
  fipeDiffRanges: string[];
  purchasePriceRanges: string[];

  createdAtIni: any;
  createdAtEnd: any;
  modelYearStart: number;
  modelYearEnd: number;
  kmStart: number;
  kmEnd: number;
  priceStart: number;
  priceEnd: number;
  makeIds: string[];
  modelIds: string[];
  cityId: string;
  uf: string;
  onlyWithExtraKey: boolean;
  onlyWithCarManual: boolean;
  updatedAtIni: string;
  updatedAtEnd: string;
  cityIds: string[];
  ufs: string[];


  constructor() {
    this.oemDealerId = null;
    this.pageControl = {
      page: 0,
      pageSize: 20,
      param: '',
      sortDirection: 'DESC',
      sortField: 'score',
      value: {},
    };
  }

  toParamMap(): Params {
    const params: Params = {};
    Object.keys(this).forEach((k) => {
      let value: any;
      if (OBJECT_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.stringify(this[k]);
      } else if (IGNORED_KEY_NAMES.indexOf(k) < 0) {
        value = this[k];
      }
      params[k] = value;
    });

    params.page = this.pageControl.page;
    params.sortField = this.pageControl.sortField;
    params.sortDirection = this.pageControl.sortDirection;
    return params;
  }

  updateFromParamMap(params: Params): void {
    Object.keys(params).forEach((k) => {
      let value: any;
      if (OBJECT_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.parse(params[k]);
      } else if (IGNORED_KEY_NAMES.indexOf(k) < 0) {
        value = params[k];
      }

      if (NUMBER_KEY_NAMES.indexOf(k) >= 0) {
        value = Number(value);
        if (value === Number.NaN) {
          value = undefined;
        }
      } else if (BOOLEAN_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.parse(value);
      }

      if (value !== undefined) {
        if (PAGE_CONTROL_KEY_NAMES.indexOf(k) >= 0) {
          this.pageControl[k] = value;
        } else {
          this[k] = value;
        }
      }
    });
  }
}

export interface EvalLeadsResponse {
  numberOfPages: number;
  actualPage: number;
  totalElements: number;
  data: EvalLead[];
}

export class EvalLead {
  id: string;
  evalDealerName: string;
  oemDealerName: string;

  name: string;
  email: string;
  phoneNumber: string;

  cityName: string;
  uf: string;
  numberPlate: string;
  trimName: string;
  modelName: string;
  makeName: string;
  segment: string;

  manufactureYear: number;
  modelYear: number;
  km: number;
  fuel: string;
  transmission: string;
  doors: number;
  color: string;

  extraKey: boolean;
  carManual: boolean;

  reason: string;

  price: number;
  minPrice: number;
  maxPrice: number;
  fipePrice: number;
  fipeDiff: number;
  createdAt: Date;
  updatedAt: Date;
  finalizedAt: Date;
  validUntil: Date;
  archivedAt: Date;

  hasFullDossier: boolean;

  status: string;

  scheduledDate: Date;
  scheduledEvalDealerName: string;
  evalVehicleId: string;
  reasonArchive?: string;
  audio?: AudioHelper;
  transcription?: TranscriptionResult;
  confidenceAudio?: string;
  sellerId: string;
  sellerName: string;

}


export enum EvalLeadStatusLabels {
  CREATED = 'Iniciada',
  NUMBER_PLATE = 'Com Veículo',
  FINISHED = 'Finalizada',
  ARCHIVED = 'Arquivada',
  SENT_TO_EVAL = 'Enviada para captação'
}



export const listStatusIconsLabels = {
  CREATED: {
    icon: 'app-icon-edit',
    class: 'created',
    label: 'INICIADA',
  },
  NUMBER_PLATE: {
    icon: 'app-icon-board',
    class: 'with-vehicle',
    label: 'COM VEÍCULO',
  },
  FINISHED: {
    icon: 'app-icon-tag',
    class: 'finished',
    label: 'FINALIZADA',
  },
  SENT_TO_EVAL: {
    icon: 'app-icon-tag',
    class: 'with-eval',
    label: 'EM CAPTAÇÃO',
  },
  ARCHIVED: {
    icon: 'material-icons',
    class: 'archived',
    label: 'ARQUIVADA',
    materialIcon: 'query_builder',
  },
};

export class EvalLeadSummary {
  startDate: Date;
  created: number;
  withVehicle: number;
  finished: number;

  sentToEval: number;

  archived: number;
  doneDeal: number;
  doneNotDeal: number;
}

export enum EvalLeadReasonArchive {
  CUSTOMER_GAVE_UP = "Cliente desistiu",
  CREDIT_REPROVED = "Crédito reprovado",
  NO_RETURN = "Sem retorno",
  PRICING = "Precificação",
  PRECAUTIONARY_REPROVED = "Cautelar reprovada",
  PRODUCT_UNAVAILABLE = "Produto indisponível",
  PURCHASED_FROM_ANOTHER_DEALER = "Comprou em outra concessionária",
  DONE_DEAL = "Deu negócio"
}

